import React, { ReactElement } from 'react';
import './Rules.scss';
import RulesTitle from '../../assets/images/kampaaniareeglid.png';

const Et: React.FC = (): ReactElement => {
  return (
    <div className="Et rules-wrapper">
      <div className="title-wrapper">
        <img src={RulesTitle} alt="" className="title-image" />
      </div>
      <ol className="rules-list">
        <li>
          Kampaania{' '}
          <span className="bold">“Tutti Frutti – Sõua suvelainele”</span> on
          alates <span className="bold">01.06.2026</span> kuni{' '}
          <span className="bold">30.06.2026</span> toimuv tarbijamäng (edaspidi
          kampaania), mida korraldab Fazer Eesti OÜ, (asukoht: Pärnu maantee
          158/1, Tallinn; edaspidi korraldaja).
        </li>
        <li>
          Kampaania auhinnafondi kuulub{' '}
          <span className="bold">
            5x Tutti Frutti SUP laud, väärtusega 205€
          </span>
          , mis loositakse välja 01.07.2026. Auhinnafondi koguväärtus on
          1025€.{' '}
        </li>
        <li>
          Kampaania läbiviimise kord on kehtestatud korraldaja poolt
          käesolevates reeglites. Kõik korraldaja otsused kampaania läbiviimisel
          on lõplikud ning kõigile kampaanias osalejatele kohustuslikud.
        </li>

        <li>
          Kampaaniatooted:
          <table>
            <tbody>
              <tr>
                <td>6416453038288</td>
                <td>Tutti Frutti Original kommikott 180g</td>
              </tr>
              <tr>
                <td>6416453036383</td>
                <td>Tutti Frutti Passion kommikott 180g</td>
              </tr>
              <tr>
                <td>6416453036413</td>
                <td>Tutti Frutti Sour kommikott 180g</td>
              </tr>
              <tr>
                <td>6416453041264</td>
                <td>Tutti Frutti Raspberry 90g</td>
              </tr>
              <tr>
                <td>6416453041271</td>
                <td>Tutti Frutti Sour Melon 90g</td>
              </tr>
              <tr>
                <td>6416453066540</td>
                <td>Tutti Frutti Smoothie Drops 100g</td>
              </tr>
              <tr>
                <td>6416453066588</td>
                <td>Tutti Frutti Smoothie Drops & Choco 200g</td>
              </tr>
              <tr>
                <td>6416453038295</td>
                <td>Tutti Frutti Original kommikott 350g</td>
              </tr>
              <tr>
                <td>6416453051430</td>
                <td>Tutti Frutti Yoghurt Splash 210g</td>
              </tr>
              <tr>
                <td>6416453033924</td>
                <td>Tutti Frutti Original kommikott 500g</td>
              </tr>
              <tr>
                <td>6416453032262</td>
                <td>Tutti Frutti Passion kommikott 500g</td>
              </tr>
              <tr>
                <td>6416453032255</td>
                <td>Tutti Frutti Sour kommikott 500g</td>
              </tr>
            </tbody>
          </table>
        </li>
        <li>
          <span className="block-span bold">
            Kampaanias osalemiseks tuleb osta vähemalt üks Tutti Frutti toode ja
            registreerida ostutšekk interneti kaudu kampaanialehel{' '}
            <a href="http://www.fazer.ee">www.fazer.ee</a>. Kampaanias osalemine
            on tasuta. Auhinna kättesaamiseks tuleb kampaania korraldajale
            esitada ostutšekk.
          </span>
          <span className="block-span">
            Loosimises osalemiseks võib ühe ostutšeki numbri esitada ainult ühe
            korra. Sama ostutšeki mitmekordsel registreerimisel osaleb ainult
            esimesena saabunud registreering.
          </span>
          <span className="block-span bold">Isikuandmete töötlemise kord</span>
          <span className="block-span">
            Fazer Eesti OÜ töötleb kampaania käigus osaleja poolt esitatud
            isikuandmeid vastavalt Eesti Vabariigis kehtivatele seadustele
            kampaania läbiviimise eesmärgil.
          </span>
          <span className="block-span">
            Kampaanias osaleja annab Fazer Eesti OÜ-le nõusoleku töödelda
            esitatud andmeid järgnevatel eesmärkidel:
          </span>
          <span className="block-span no-padding">
            kampaania tulemuste kohta kokkuvõtete tegemiseks;
          </span>{' '}
          <span className="block-span no-padding">
            kampaaniaga seotud koostööpartneritele info edastamiseks;
          </span>{' '}
          <span className="block-span no-padding">
            võitjate välja loosimiseks ja nende teavitamiseks;
          </span>{' '}
          <span className="block-span">
            võitjate nimede avaldamiseks kampaania veebilehel.
          </span>
          <span className="block-span">
            Kampaanias osalejatel on õigus saada lisainfot Fazer Eesti OÜ poolt
            isikuandmete töötlemise kohta. Selleks tuleb saata e-kiri
            aadressile: <a href="mailto:info@fazer.ee"> info@fazer.ee</a>{' '}
          </span>
          <span className="block-span">
            Isikuandmete vastutav töötleja on Fazer Eesti OÜ, registrikood
            10057691, Pärnu maantee 158/1, Tallinn 11317; tel 6502421;
            <a href="mailto:info@fazer.ee"> info@fazer.ee</a>
          </span>
          <span className="block-span">
            Kogutud andmeid säilitatakse kolm kuud alates kampaania
            lõpukuupäevast ehk kuni 30.09.2026. Võitjate täielik nimekiri on
            veebilehel üleval kuni 31.07.2026.
          </span>
        </li>
        <li>
          <span className="block-span">
            <span className="bold">01.07.2026</span> loositakse kell 12:00
            kõikide kampaanias osalejate vahel välja{' '}
            <span className="bold">
              5x Tutti Frutti SUP laud, väärtusega 205€. Auhinnafondi
              koguväärtus on 1025€.
            </span>
          </span>
          Auhinna loosimises osalevad kõik veebis registreerunud isikud
          kampaania reeglites esitatud perioodil (alates keskkonna avanemisest).
          Võitjat informeeritakse telefoni või meili teel. Loosimise juures
          viibib vähemalt üks Fazer Eesti OÜ esindaja.
        </li>
        <li>
          Auhinna võitja nimi avaldatakse internetis aadressil{' '}
          <a href="http://www.fazer.ee">www.fazer.ee </a>
          hiljemalt loosimisele järgneval kolmandal tööpäeval. Võitjaga võetakse
          korraldaja esindaja poolt ühendust andmete ja auhinna
          kättetoimetamisviisi täpsustamiseks.
        </li>
        <li>
          Juhul, kui auhinna võitja ei vasta korraldaja poolt kehtestatud
          kampaania tingimustele või kui ta ei ole alles hoidnud toote
          ostutšekki, millel oleva numbri ta edastas kampaania korraldajale
          veebi vahendusel, on õigus auhind uuesti välja loosida järgmisele
          isikule. Samuti juhul, kui auhinna võitja ei ole hiljemalt nädala
          jooksul alates, tema kui auhinna võitja nime avalikustamist internetis
          aadressil <a href="http://www.fazer.ee">www.fazer.ee</a> olnud veebis
          esitatud kontaktandmetel kättesaadav andmete täpsustamiseks, on
          korraldajal õigus jätta talle auhind üle andmata ning korraldada uus
          loosimine.{' '}
        </li>
        <li>
          Korraldajalt ükskõik missuguse kampaania auhinna saaja annab loa
          korraldajale kasutada võitja nime meedias, reklaamides,
          PR-kampaaniates jms üritustel ilma võitjale selle eest täiendavat tasu
          maksmata ja vastavat kokkulepet sõlmimata.{' '}
        </li>
        <li>
          Kampaania käigus kampaanias osaleja poolt võidetud auhinda ei asendata
          võitja nõudmisel teist liiki auhinnaga ega hüvitata võitjale auhinna
          maksumust rahas, v.a juhul, kui auhind asendatakse teise samaväärse
          auhinnaga korraldaja otsusel.{' '}
        </li>
        <li>
          Auhinna võitjale üleandmisega seotud riiklikud maksud tasub korraldaja
          Eesti Vabariigi seadustes sätestatud korras ja tähtaegadel.{' '}
        </li>
        <li>
          Kampaanias osaleja poolt kampaania tingimuste eiramise või
          korraldajale enda kohta valede või ebatäpsete andmete esitamise
          korral, samuti muude ebaõnnestumiste korral (korraldajal ei õnnestu
          auhinna võitjaga kontakti saada), mis ei ole tingitud korraldaja
          süüst, ei vastuta korraldaja kampaanias osaleja auhindade loosimisest
          või auhinna kätteandmisest kõrvalejäämise eest.{' '}
        </li>
        <li>
          {' '}
          Vääramatu jõu (force majeure) asjaolude ilmnemisel on korraldajal
          ühepoolne õigus katkestada kampaania ja jätta auhinnad välja loosimata
          ja/või auhinnad võitjatele üle andmata, teatades sellest koheselt
          kampaanias osalejatele meedia vahendusel.{' '}
        </li>
        <li>
          Kõik kampaaniast tulenevad vaidlused lahendatakse vastavalt Eesti
          Vabariigi seadusandlusele.
        </li>
        <li>
          Kõik pretensioonid seoses kampaania korraldamise ja/või läbiviimisega
          tuleb saata kirjalikult kampaania korraldaja asukohta: Pärnu maantee
          158/1, 11317 Tallinn märksõnaga{' '}
          <span className="bold">“KAMPAANIA"</span> hiljemalt 01.07.2026.
          Kaebused, mis esitatakse peale nimetatud kuupäeva, ei võeta menetluse.
          Laekunud pretensioonidele vastatakse 3 tööpäeva jooksul.
          <span className="block-span">
            Kampaania lisainfo telefonil 650 2421;{' '}
            <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
          </span>
        </li>
      </ol>
    </div>
  );
};

export default Et;
